import { Trophy } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";
import { ACHIEVEMENTS } from "@/content";

export const Achievements = () => (
  <section
    id="achievements"
    data-testid="achievements-section"
    className="scroll-mt-24 px-6 py-24 sm:px-12 lg:px-20 lg:py-32"
  >
    <div className="mx-auto max-w-7xl">
      <SectionHead
        label="03 — Achievements"
        title="Proof, not promises."
        testId="achievements-heading"
      />

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:gap-8" data-testid="achievements-grid">
        {ACHIEVEMENTS.map((a, i) => (
          <Reveal key={a.title} delay={i * 0.1}>
            <div
              data-testid={`achievement-card-${i + 1}`}
              className="group relative overflow-hidden rounded-[1.75rem] border border-border/60 shadow-lg transition-transform duration-500 hover:-translate-y-1.5"
            >
              <div className="relative h-72 overflow-hidden sm:h-80">
                <img
                  src={a.image}
                  alt={a.alt}
                  data-testid={`achievement-image-${i + 1}`}
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.05]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/25 to-transparent" />
              </div>

              <div className="absolute inset-x-0 bottom-0 p-6 sm:p-8">
                <p className="mb-2 flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-honey">
                  <Trophy size={12} />
                  Achievement
                </p>
                <h3 className="font-serif text-2xl tracking-tight text-[#FAF7F2] sm:text-3xl">
                  {a.title}
                </h3>
                <p className="mt-2 max-w-md text-sm leading-relaxed text-white/80">{a.body}</p>
              </div>

              <span className="absolute right-5 top-5 rounded-full bg-background/85 px-4 py-2 font-serif text-lg text-terra backdrop-blur-md">
                {a.stat}
                <span className="ml-1.5 font-mono text-[9px] uppercase tracking-[0.14em] text-muted-foreground">
                  {a.statLabel}
                </span>
              </span>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
